import React, {cloneElement, ReactElement, useEffect, useState} from 'react'
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { TComponentTooltip } from "./_types"

const ComponentTooltip: React.FC<TComponentTooltip> = ({ children, title, placement = "auto", tooltipClassName = "", show: externalShow }) => {
    /* position: fixed решает проблему с мерцанием скролла у body */

    /* Если prop show передан -> компонент контролируется извне,
       иначе управляет показом по hover самостоятельно.

       Hover-логика навешивается на дочерний элемент (mouseenter, mouseleave).
       В контролируемом режиме hover игнорируется.
    */
    const [internalShow, setInternalShow] = useState(false)
    const isControlled = externalShow !== undefined
    const show = isControlled ? externalShow : internalShow

    /* Tooltip автоматически скрывается при любом scroll, если show не управляется извне
       Необходимо для того, чтобы Tooltip не отображался, если элемент уже скрыт за границами контейнера
    */

    useEffect(() => {
        if (!show) return
        const onScroll = () => !isControlled && setInternalShow(false)
        window.addEventListener("scroll", onScroll, true)
        return () => window.removeEventListener("scroll", onScroll, true)
    }, [show, isControlled])

    return <OverlayTrigger show={show} trigger={[]} placement={placement} overlay={
        <Tooltip className={`componentTooltip ${tooltipClassName}`} placement="auto">
            {title}
        </Tooltip>
    }>
        {cloneElement(children as ReactElement, {
            onMouseEnter: () => !isControlled && setInternalShow(true),
            onMouseLeave: () => !isControlled && setInternalShow(false),
        })}
    </OverlayTrigger>
}

export default ComponentTooltip